<header>
    <div class="app-bar-navbar fixed-top horizontal-navbar">
        <div *ngIf="resourceKeyValue.loginViewMaintenanceMsg?.length > 0"
            class="alert alert-warning flex-row tabfocusable alert-banner" focusClass="alert-warning-focus" role="alert"
            [innerHTML]="resourceKeyValue.loginViewMaintenanceMsg">
        </div>
        <nav class="navbar navbar-expand-lg navbar-dark bg-primary app-bar-section pr-0 d-flex">
            <div class="navbar-brand d-flex align-items-center">
                <img src="assets/images/logo/secondary-logo-site.svg" class="logo-img" alt="BD logo">
                <span class="brand-name">{{applicationNameFinalLabel}}</span>
            </div>
            <div class="navbar-right-content justify-content-end d-flex">
                <div class="navbar-right-toggle d-flex">
                    <ul class="navbar-nav">
                        <li class="nav-item dropdown-appbar d-flex">
                            <span class="vertical-line-seperator left">&nbsp;</span>
                            <button class="nav-link navbar-toggler tabfocusable" id="navbarDropdownMenuLink"
                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                aria-controls="menu-list1">
                                <i class="icon-more-bold text-white rotate-90"></i>
                            </button>
                            <ul class="dropdown-menu pull-right" aria-labelledby="dLabe2" id="menu-list1">
                                <li class="nav-item">
                                    <a (click)="signOut()" role="menuitem"
                                        class="dropdown-item">{{resourceKeyValue.signOut}}</a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>

                <div class="custom-dropdown d-flex" tabindex="1">
                    <ul class="navbar-nav">
                        <li class="nav-item dropdown-appbar d-flex">
                            <span class="vertical-line-seperator left">&nbsp;</span>
                            <button class="nav-link dropdown-toggle tabfocusable" id="navbarDropdownMenuLink"
                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                                aria-controls="menu-list2">
                                {{userName}}
                            </button>
                            <ul class="dropdown-menu pull-right" aria-labelledby="dLabe2" id="menu-list2">
                                <li>
                                    <a (click)="signOut()" role="menuitem"
                                        class="dropdown-item">{{resourceKeyValue.signOut}}</a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
        <div class="dashBoardAppBar">
            <label>{{resourceKeyValue.dashBoardIDNLabel}}</label>
            <span>{{dashboardIDNName === '' ? resourceKeyValue.dashBoardNoIDNAvailable : dashboardIDNName}}</span>
            <label>{{resourceKeyValue.dashBoardFacilityLabel}}</label>
            <span>{{dashboardFacilityName === '' ? resourceKeyValue.dashBoardNoFacilityAvailable :
                dashboardFacilityName}}</span>
            <a *ngIf="!changeButtonVisibility" href="javascript:void(0);" data-toggle="modal" data-keyboard="true"
                data-target="#navpopupwindow" (click)="onDashboardBarChange()">
                {{resourceKeyValue.dashBoardChangeBtn}}
            </a>
        </div>
        <div *ngIf="!HasManageUserRole" class="horizontal-navigation navbar">
            <ul class="navbar-nav mr-auto">
                <li class="nav-item dropdown" *ngFor="let navItem of navMenu?.navItems">
                    <a class="nomal" (click)="subMenuclick='1';" id="navItem{{removeBlanks(navItem.name)}}"
                        *ngIf="!navItem.subNavItems && navItem.name !='menuSubItemUsers'" routerLinkActive="active"
                        [routerLink]="[navItem.routerLink]">{{resourceKeyValue[navItem.name]}}
                        <i *ngIf="navItem.isExternal" class="icon-new-tab-bold"></i></a>
                        <span class="nomal"
                                    *ngIf="navItem.name == 'menuSubItemUsers'"><a
                                        id="subItem{{removeBlanks(navItem.name)}}"
                                        (click)="getUserManagementUrl()">{{resourceKeyValue[navItem.name]}}</a><i
                                        *ngIf="navItem.isExternal" class="icon-new-tab-bold icon"></i></span>
                    <ngcontainer *ngIf="navItem.subNavItems">
                        <a id="navbardrop" id="navItem{{removeBlanks(navItem.name)}}"
                            [ngClass]="subMenuclick=='2' ?'selected':''"
                            data-toggle="dropdown">{{resourceKeyValue[navItem.name]}}</a>
                        <div class="dropdown-menu fix-subitems">
                            <ngcontainer *ngFor="let subitem of navItem.subNavItems">
                                <a class="dropdown-item" (click)="subMenuclick='2';"
                                    *ngIf="subitem.name !='menuSubItemUsers'" id="subItem{{removeBlanks(subitem.name)}}"
                                    [routerLink]="subitem.routerLink" href="#">{{resourceKeyValue[subitem.name]}}</a>
                                <span class="dropdown-item padding-0 bg-grey"
                                    *ngIf="subitem.name == 'menuSubItemUsers'"><a
                                        id="subItem{{removeBlanks(subitem.name)}}"
                                        (click)="getUserManagementUrl()">{{resourceKeyValue[subitem.name]}}</a><i
                                        *ngIf="subitem.isExternal" class="icon-new-tab-bold icon"></i></span>
                            </ngcontainer>
                        </div>
                    </ngcontainer>
                </li>
            </ul>
        </div>
    </div>
</header>
<app-loader [isLoading]=isLoading></app-loader>
<!-- Modal Window -->
<div class="modal expiry-modal fade" id="navpopupwindow" #popupwindow tabindex="-1" role="dialog"
    aria-labelledby="popupWindowLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h3 class="modal-title" id="gridSystemModalLabel">{{resourceKeyValue.dashBoardModalTitle}}</h3>
                <button tabindex="0" type="button" class="close tabfocusable" data-dismiss="modal" aria-label="Close">
                    <i id="" class="icon-close-bold-sm"></i>
                </button>
            </div>
            <div class="modal-body">
                <form content [formGroup]="facilityForm" id="facilityForm">
                    <div class="form-group modal-controls">
                        <label class="control-label" for="idn">{{resourceKeyValue.idnModalLbl}}</label>
                        <select class="custom-select modal-select-field" id="idn" formControlName="idn"
                            (change)="selectedIdnIDValue(facilityForm.get('idn')?.value)">
                            <option *ngIf="allIdns?.length>0" [value]="null" selected>{{resourceKeyValue.hintSelectIDN}}
                            </option>
                            <option *ngIf="allIdns?.length==0" [ngValue]=0 disabled selected>
                                {{resourceKeyValue.noIDNAvailable}}</option>
                            <option *ngFor="let idn of allIdns" [value]="idn.id">{{idn.name}}</option>
                        </select>
                    </div>
                    <div class="form-group select-facility select-fac-div modal-select-field">
                        <label class="control-label" for="facilityId">{{resourceKeyValue.facilityModalLbl}}</label>
                        <select class="custom-select" id="facilityId" formControlName="facilityId"
                            [attr.disabled]="allIdns && allIdns.length > 0 ? null : ''">
                            <option *ngIf="hospitals?.length>0" [ngValue]="null" selected>
                                {{resourceKeyValue.hintSelectFacility}}</option>
                            <option *ngIf="hospitals?.length==0" [ngValue]="null" disabled selected>
                                {{resourceKeyValue.noFacilityAvailable}}</option>
                            <option *ngFor="let hospital of hospitals" [ngValue]="hospital">{{hospital.name}}
                            </option>
                        </select>
                    </div>
                    <div class="modal-footer modal-footer-btns">
                        <button class="btn btn-secondary"
                            data-dismiss="modal">{{resourceKeyValue.cancelDashBoardModalBtn}}</button>
                        <button class="btn btn-primary ml-4" data-dismiss="modal"
                            (click)="changeCulture(facilityForm.get('facilityId')?.value)"
                            [disabled]="!this.selectedHospital || this.selectedIdnID === 0">{{resourceKeyValue.changeDashBoardModalBtn}}</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>